// Выполняет действия при переключении адаптивных режимов
function adaptiveLayoutScript() {
	var width = $(window).outerWidth();
}


// Возвращает минимальное значение из двух
function minValue(a, b) {
	return a < b ? a : b;
}


// Возвращает максимальное значение из двух
function maxValue(a, b) {
	return a > b ? a : b;
}


// Находит в массиве заданный элемент и возвращает его индекс
function findInArray(array, value) {
	for (var i = 0; i < array.length; i++) {
		if (array[i] == value) return i;
	}
	return -1;
}


// Возвращает дату воскресенья на неделе, к которой относится указанная дата
function getSundayDate(d) {
	return d.getDate() + (d.getDay() == 0 ? 0 : (7 - d.getDay()));
}